import { useNavigate } from 'react-router-dom';

const HERO_WORDS = [
  { t: 'South ', d: '.20s' },
  { t: "Florida's ", d: '.32s' },
  { t: 'Leading ', d: '.44s' },
  { t: 'Experts ', d: '.56s' },
  { t: 'in ', d: '.68s' },
  { t: 'ChatGPT Ads ', d: '.80s', color: '#0D9488', br: true },
  { t: '& ', d: '.92s' },
  { t: 'AI Marketing ', d: '1.04s' },
  { t: 'for Home Services', d: '1.16s' },
];

const POSTER =
  'https://images.unsplash.com/photo-1519046904884-53103b34b206?auto=format&fit=crop&w=2000&q=60';
const VIDEO = 'https://videos.pexels.com/video-files/3403385/3403385-uhd_2560_1440_24fps.mp4';

export default function HeroSection() {
  const navigate = useNavigate();

  return (
    <section id="home" className="relative overflow-hidden" style={{ minHeight: '100vh' }}>
      <div className="absolute inset-0 z-0 video-light-tint">
        <video
          autoPlay
          loop
          muted
          playsInline
          poster={POSTER}
          className="absolute inset-0 w-full h-full object-cover ken-burns"
        >
          <source src={VIDEO} type="video/mp4" />
        </video>
      </div>

      <div className="pointer-events-none absolute inset-0 flex items-center justify-center z-0">
        <div className="orbit w-[900px] h-[900px] absolute float-y"></div>
        <div className="orbit w-[1300px] h-[1300px] absolute"></div>
        <div className="orbit w-[1700px] h-[1700px] absolute"></div>
      </div>

      {/* Floating Voice-AI badge */}
      <div
        className="hidden lg:flex absolute z-20 top-32 right-10 lg:right-20 items-center gap-3 glass-strong rounded-2xl px-4 py-3 blur-in"
        style={{ animationDelay: '1.3s' }}
      >
        <div className="relative">
          <div className="icon-pill"><i className="ri-phone-fill text-teal-500"></i></div>
          <span className="pulse-ring absolute inset-0 rounded-full bg-teal-400/40"></span>
        </div>
        <div className="text-left">
          <div className="text-[10px] uppercase tracking-wider text-teal-600 font-body font-bold">
            Incoming · 2:47 AM
          </div>
          <div className="text-sm text-slate-900 font-body font-semibold">
            Voice AI answering &amp; booking…
          </div>
        </div>
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-6 pt-40 pb-24 text-center flex flex-col items-center">
        <div className="eyebrow blur-in" style={{ animationDelay: '.15s' }}>
          <span className="bg-gradient-to-r from-[#F97316] to-[#FB923C] text-white rounded-full px-2.5 py-0.5 text-[10px] font-ui font-bold">
            NEW
          </span>
          ChatGPT Ads · GEO · Voice AI for Florida Contractors
        </div>

        <h1 className="mt-8 h-display text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-[5.25rem] leading-[1.0] md:leading-[0.95] tracking-[-0.02em] max-w-5xl">
          {HERO_WORDS.map((w, i) => (
            <span key={i}>
              <span className="blur-word" style={{ animationDelay: w.d, color: w.color }}>
                {w.t}
              </span>
              {w.br && <br />}
            </span>
          ))}
        </h1>

        <p
          className="blur-in mt-7 max-w-2xl text-base md:text-lg text-slate-600 font-body font-light leading-relaxed"
          style={{ animationDelay: '1.30s' }}
        >
          Get recommended by ChatGPT, run profitable OpenAI ads, and capture every lead with 24/7
          Voice AI. We help Florida{' '}
          <strong className="text-slate-800">
            roofers, plumbers, HVAC, restoration, electrical, and garage door pros
          </strong>{' '}
          win the AI-search era.
        </p>

        <div className="blur-in mt-8 flex flex-wrap justify-center gap-3" style={{ animationDelay: '1.45s' }}>
          <span className="glass rounded-full px-3.5 py-1.5 text-xs text-slate-700 font-body font-medium">
            <i className="ri-robot-2-line text-[color:var(--orange)] mr-1.5"></i>Recommended by ChatGPT
          </span>
          <span className="glass rounded-full px-3.5 py-1.5 text-xs text-slate-700 font-body font-medium">
            <i className="ri-search-eye-line text-[color:var(--orange)] mr-1.5"></i>Generative Engine Optimization
          </span>
          <span className="glass rounded-full px-3.5 py-1.5 text-xs text-slate-700 font-body font-medium">
            <i className="ri-phone-fill text-[color:var(--orange)] mr-1.5"></i>24/7 Voice AI
          </span>
        </div>

        <div className="blur-in mt-9 flex flex-col sm:flex-row items-center gap-4" style={{ animationDelay: '1.55s' }}>
          <button
            onClick={() => navigate('/audit')}
            className="fdme-cta inline-flex items-center gap-2 px-6 py-3 text-sm"
          >
            Get Your Free AI Marketing Audit <i className="ri-arrow-right-up-line"></i>
          </button>
          <button
            onClick={() => navigate('/chatgpt-ads')}
            className="glass-strong inline-flex items-center gap-2 rounded-full px-6 py-3 text-sm text-slate-800 font-body font-semibold"
          >
            <i className="ri-calendar-event-line text-orange-500"></i> Book a ChatGPT Ads Strategy Call
          </button>
        </div>

        <a
          href="https://wa.me/19542964896"
          target="_blank"
          rel="noopener noreferrer"
          className="blur-in mt-6 inline-flex items-center gap-2 text-sm text-teal-600 font-body font-semibold hover:text-teal-500"
          style={{ animationDelay: '1.65s' }}
        >
          <i className="ri-whatsapp-line text-base"></i> WhatsApp us: (954) 296-4896
        </a>

        {/* Pillar marquee */}
        <div className="mt-20 w-full max-w-5xl">
          <div className="overflow-hidden">
            <div className="flex gap-14 marquee-track whitespace-nowrap">
              {[
                'ChatGPT Ads',
                'Generative Engine Optimization',
                'Voice AI Agents',
                'Perplexity Visibility',
                'Lead Capture',
              ]
                .concat([
                  'ChatGPT Ads',
                  'Generative Engine Optimization',
                  'Voice AI Agents',
                  'Perplexity Visibility',
                  'Lead Capture',
                ])
                .map((label, i) => (
                  <span key={i} className="h-display text-2xl md:text-3xl opacity-80">
                    {label}
                  </span>
                ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
